// app/components/form-sections/SavedLettersSection.jsx
"use client";
import Field from "../ui/Field";

export default function SavedLettersSection({
  savedLettersList,
  selectedSavedId,
  setSelectedSavedId,
  onLoad,
  onDelete,
}) {
  return (
    <div className="rounded-2xl border border-gray-200 bg-white">
      <div className="flex items-center justify-between px-4 py-3 sm:px-5 border-b border-gray-200">
        <span className="text-[13px] sm:text-sm font-semibold text-slate-900">Load Saved Letter</span>
      </div>
      <div className="p-4 sm:p-5 grid gap-3">
        {savedLettersList.length === 0 ? (
          <div className="text-sm text-gray-500">
            No saved letters yet. Generate a letter, then click <b>Save</b> in the preview panel.
          </div>
        ) : (
          <div className="grid sm:grid-cols-[1fr_auto_auto] gap-2 items-center">
            <div className="relative">
              <select
                value={selectedSavedId}
                onChange={(e) => setSelectedSavedId(e.target.value)}
                className="w-full appearance-none rounded-xl px-3 py-2.5 pr-10 text-sm md:text-base
                           bg-white hover:bg-slate-100 border border-gray-200 text-gray-700 shadow-sm
                           outline-none focus:border-teal-600 focus:ring-2 focus:ring-teal-600/40"
              >
                <option value="" disabled>— Select —</option>
                {savedLettersList.map((s) => (
                  <option key={s.id} value={s.id}>
                    {[s.student || "Student", s.college || "College", s.templateId || "template", s.date || ""]
                      .filter(Boolean).join(" • ")}
                  </option>
                ))}
              </select>
              <svg className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-500" viewBox="0 0 20 20" fill="currentColor" aria-hidden>
                <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 10.94l3.71-3.71a.75.75 0 1 1 1.06 1.06l-4.24 4.24a.75.75 0 0 1-1.06 0L5.21 8.29a.75.75 0 0 1 .02-1.08z" clipRule="evenodd" />
              </svg>
            </div>
            <button
              type="button"
              onClick={() => selectedSavedId && onLoad(selectedSavedId)}
              className="rounded-lg bg-gradient-to-r from-teal-600 to-orange-600 px-3 py-2 text-white text-sm font-semibold shadow-md hover:from-teal-700 hover:to-orange-700"
              disabled={!selectedSavedId}
            >
              Load
            </button>
            <button
              type="button"
              onClick={() => selectedSavedId && onDelete(selectedSavedId)}
              className="rounded-lg border border-rose-200 bg-rose-50 px-3 py-2 text-sm font-semibold text-rose-700 hover:bg-rose-100"
              disabled={!selectedSavedId}
            >
              Delete
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
